// External
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Injectable } from '@angular/core';

// Internal
import { ParentalService } from '../process/parental/parental.service';
import { ValuesService } from '../../values/values.service';
import { ProfilesService } from '../process/profiles/profiles.service';
import { OrderValuesByNamePipe } from '../../pipes/pipes';
import { UrlProperties } from './models/UrlProperties.model';
import { UtilsCommonService } from '../../utils/utils-common.service';
import { NavigationService } from '../../navigation/navigation.service';

@Injectable({ providedIn: 'root' })

export class ParentalGuard {

    constructor(
        private readonly parentalService: ParentalService,
        private readonly router: Router,
        private readonly valuesService: ValuesService,
        private readonly profilesService: ProfilesService,
        public readonly orderValuesByName: OrderValuesByNamePipe,
        private readonly utilsService: UtilsCommonService,
        private readonly navigationService: NavigationService,
    ) { }

    computeValidChildRedirect(urlProperties: UrlProperties) {
        let profiles = this.profilesService.getParentalProfiles();
        let orderedProfiles = this.orderValuesByName.transform(profiles);
        let profileHash = urlProperties.urlParams?.child;

        if (!this.utilsService.isEmptyObject(profiles) && (!profileHash || !profiles[profileHash]) ) {
            return this.router.parseUrl(`${this.valuesService.centralPaths.parental.path}/${orderedProfiles[0]['key']}${urlProperties.outletsString}`);
        } else if (this.utilsService.isEmptyObject(profiles) && profileHash) {
            return this.router.parseUrl(this.valuesService.centralPaths.parental.path);
        }
        return false;
    }

    // guard to activate a route
    // asta se ruleaza doar cand nu am /:id in path sau cand calea incepe cu parental si nu se face match cu vreun copil din organiser.routes
    // daca am profile_id, il transform in hash si se reia logica din parental.organiser.routes (adica se incearca sa se faca match din nou)
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean|UrlTree {
        const urlProperties = this.navigationService.processUrl(route, state);
        this.parentalService.showSubsections();
        const subpath = route.routeConfig.path;
        if (this.parentalService.subsections.hasOwnProperty(subpath) && !this.parentalService?.subsections[subpath]?.show) {
            const path = route?.params?.child ? this.valuesService.centralPaths.parental.path : this.valuesService.centralPaths.parental.path.concat("/", route?.params?.child);
            return this.router.createUrlTree([path]);
        }
        const _redirect = this.computeValidChildRedirect(urlProperties);
        if (_redirect) {
            return _redirect;
        }
        return true;
    }

}
